/**
 * Constant variables
 */
const validAccountPrinterReceiptFormats = [
  'Succinct',
  'Verbose',
];
const validAccountTypes = [
  'Admin',
  'Delegated admin',
  'Super admin',
  'User',
];
const validCustomerPropertyTypes = [
  'Agent',
  'Dealer',
  'Runner',
  'Super dealer',
];
const validCustomerRunnerTicketConversionModes = [
  'Input',
  'Output',
];
const validDealCompilers = [
  'Legacy',
  'Mobile',
  'PC-A',
  'PC-B',
  'PC-C',
];
const validManipulationModes = [
  'Permutation',
  'Running',
  'Special',
  'Straight',
];
const validSystemPermissionTypes = [
  'Advanced',
  'Basic',
  'Essential',
];
module.exports = {
  validAccountPrinterReceiptFormats,
  validAccountTypes,
  validCustomerPropertyTypes,
  validCustomerRunnerTicketConversionModes,
  validDealCompilers,
  validManipulationModes,
  validSystemPermissionTypes,
};
